import axios from 'axios';
import { getUnbrandedHeaders } from './apiService';

export function getSendOtpPayload(
  phoneNumber,
  lang,
  brand,
  countryCode = 'EG'
) {
  return { phoneNumber, lang, brand, countryCode };
}

export function getVerifyOtpPayload(code, vToken, brand, countryCode = 'EG') {
  return { code, vToken, brand, countryCode };
}

export async function sendOtp(phoneNumber) {
  const API_URL_UTILITY = process.env.REACT_APP_MULE_API_UTILITY;

  const params = {
    method: 'POST',
    url: `${API_URL_UTILITY}/v1/api/v1/send-login-otps`,
    headers: getUnbrandedHeaders(),
  };
  const payload = getSendOtpPayload(phoneNumber, 'ar', 'MARLBORO');

  const initObj = {
    method: params.method,
    headers: params.headers,
    url: params.url,
    data: payload,
  };
  return axios(initObj)
    .then((res) => res?.data)
    .catch((err) => err);
}
export async function verifyOtp(input) {
  const API_URL_UTILITY = process.env.REACT_APP_MULE_API_UTILITY;

  const params = {
    method: 'POST',
    url: `${API_URL_UTILITY}/v1/api/v1/verify-login-otps`,
    headers: getUnbrandedHeaders(),
  };
  const payload = getVerifyOtpPayload(input.code, input.vToken, 'MARLBORO');
  const initObj = {
    method: params.method,
    headers: params.headers,
    url: params.url,
    data: payload,
  };

  return axios(initObj)
    .then((res) => res?.data)
    .catch((err) => err);
}
